import React, { useState, Dispatch } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';

import { useForm, FormProvider } from 'react-hook-form';

import { Typography } from '@mui/material';

import { ContentToggler } from './Container';
import { handleSwitchTemplate, handleCloseTemplate } from './switchHandlers';

import { AuthAlternative, Error, LinkStyled } from './styles';
import { ButtonStyled, DialogActionsStyled } from 'elements/mismosh';

import { sendMeForgotPasswordCode } from 'components/authorization/cognitoUtils';
import { Phone, e164Formatter } from 'components/phone';

type FormData = { phone: string };

interface Props {
  switchToClose: ContentToggler;
  switchToSignIn: ContentToggler;
  setUsername: Dispatch<string>;
}

/**
 * For a non-logged-in user to reset their password.
 *
 * They are confirming their identify by phone.
 */
export const ForgotPasswordSendMeCode: React.FC<Props> = ({
  switchToClose,
  switchToSignIn,
  setUsername,
}) => {
  const [apiError, setApiError] = useState('');
  const methods = useForm<FormData>({ defaultValues: { phone: '' } });

  const handleClose = handleCloseTemplate(switchToClose);
  const handleGotoSignin = handleSwitchTemplate(switchToSignIn, handleClose);

  const onSubmit = async ({ phone }: FormData, e: React.SyntheticEvent) => {
    e.preventDefault();
    try {
      const e164 = e164Formatter(phone);
      setApiError(undefined);
      setUsername(e164);
      await sendMeForgotPasswordCode(e164);
      handleClose();
    } catch (err) {
      setApiError(err?.message);
      console.log('error...: ', err);
    }
  };

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <DialogTitle id="signin-modal">Reset Password</DialogTitle>
          <Phone />
          {methods.formState.errors.phone && <Error>Field is required</Error>}
          {!!apiError && <Error>{apiError}</Error>}
          <DialogActionsStyled>
            <ButtonStyled
              name="signin-submit"
              variant="contained"
              color="primary"
              type="submit"
            >
              Send Phone Code
            </ButtonStyled>
          </DialogActionsStyled>
          <AuthAlternative>
            <Typography variant="caption">Remember password?</Typography>
            <LinkStyled onClick={handleGotoSignin}>Signin</LinkStyled>
          </AuthAlternative>
        </form>
      </FormProvider>
    </Dialog>
  );
};
